import { Component, inject, OnInit } from '@angular/core';
import { CustomerService, FavouriteProductsService, GungNavbarComponent } from 'gung-standard';
import { first } from 'rxjs';

@Component({
    selector: 'car-liner-navbar',
    templateUrl: './car-liner-navbar.component.html',
    styleUrls: ['./car-liner-navbar.component.scss'],
    standalone: false
})
export class CarLinerNavbarComponent extends GungNavbarComponent implements OnInit {
  protected favouriteProductsService = inject(FavouriteProductsService);
  protected customerService = inject(CustomerService);

  favouritesCount = 0;
  isUser = false;
  moreThanOneCustomer = false;

  ngOnInit(): void {
    super.ngOnInit();

    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isUser =
          roles.indexOf('USER') > -1 &&
          roles.indexOf('SALES') === -1 &&
          roles.indexOf('ADMIN') === -1 &&
          roles.indexOf('DISTRIBUTOR') === -1;
      });

    this.getFavorites();

    this.customerService
      .getCustomers()
      .pipe(first())
      .subscribe(customers => {
        this.moreThanOneCustomer = !!customers && customers.length > 1;
      });
  }

  getFavorites(): void {
    this.favouriteProductsService.getFavouritesByFlow().subscribe((products: any[]) => {
      this.favouritesCount = products.length;
    });
  }

  logout(): void {
    this.authService.logout();
  }
}
